import { Box, styled } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(2)
}));

export const DateNavigationContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4)
}));
